import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CreateOrUpdateOrderItem, OrderItem } from '@interfaces';

@Component({
  selector: 'unicon-order-item',
  templateUrl: './order-item.component.html',
})
export class OrderItemComponent {
  @Input() leadOrder: OrderItem[] = [];
  @Input() isActivated!: boolean;
  @Output() edit: EventEmitter<{
    orderId: string;
    formValue: CreateOrUpdateOrderItem;
  }> = new EventEmitter<{
    orderId: string;
    formValue: CreateOrUpdateOrderItem;
  }>();
  @Output() delete: EventEmitter<string> = new EventEmitter<string>();
  @Output() showAddItemButton: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  protected itemId: string = '';
  protected updating: boolean = false;

  protected onUpdate(itemId: string): void {
    this.itemId = itemId;
    this.updating = !this.updating;
    this.showAddItemButton.emit(this.updating);
  }

  protected onEditResult(
    formValue: CreateOrUpdateOrderItem,
    orderId: string,
  ): void {
    this.edit.emit({
      orderId,
      formValue,
    });
    this.onUpdate('');
  }
}
